import React, { useEffect } from 'react';
import Locale from 'src/i18n';
import { injectIntl } from 'react-intl';
import {
    Dialog,
    ScreenMessagePanelContainer,
    FormFieldContainer,
    ButtonLight,
    ButtonStandard,
    formatMessage,
    TextField,
    Label,
} from 'cw-ui-core';
import css from './EditImportedUserDialog.scss';

export const EDIT_IMPORTED_USER_DIALOG = 'EDIT_IMPORTED_USER_DIALOG';

const EditImportedUserDialog = props => {
    const { onDidMount } = props;
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const dialogButtons = [
        <ButtonLight
            key="cancelEditEmail"
            automationName="cancelEditEmail"
            value={formatMessage(Locale.cancel)}
            className={css.cancelButton}
            onClick={props.onCancelButtonClick}
        />,
        <ButtonStandard
            key="saveEditEmail"
            automationName="saveEditEmail"
            text={formatMessage(Locale.save)}
            onClick={props.onSaveButtonClick}
            value={formatMessage(Locale.save)}
            className={css.saveButton}
            disabled={props.disabledSave}
        />,
    ];

    return (
        <Dialog
            dialogId={EDIT_IMPORTED_USER_DIALOG}
            header={formatMessage(Locale.editImportedUser)}
            buttons={dialogButtons}>
            <Label className={css.importedEmailText} value={formatMessage(Locale.importedUserEmailText)} />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={EDIT_IMPORTED_USER_DIALOG} />
                <FormFieldContainer
                    path={['userDetails', 'email']}
                    screenKey={EDIT_IMPORTED_USER_DIALOG}
                    className={css.inputBox}>
                    <TextField className={css.inputField} />
                </FormFieldContainer>
            </div>
        </Dialog>
    );
};

export default injectIntl(EditImportedUserDialog);
